<template>
	<div class="input__wrapper">
		<label :class="data.searchLabel">
		<span class="input-label" :id="data.labelId">{{ data.label }}</span>
			<input
				:type="data.type"
				:id="data.inputId"
				:name="data.name"
				:placeholder="data.placeholder"
				:class="data.searchClass"
				v-model="inputVal"
				v-debounce:500="triggerKeys"
				:disabled="isDisabled"
				ref="searchInput"
				autocomplete="off"
				@blur="focusLost"
				@focus="hasFocus"
				@change="checkType($event)"
				@keydown="checkType($event)"
			/>
		</label>
	</div>
</template>

<script>
import { restrictSpecialCharacters } from '@/config/util';

export default {
	props: {
		data: {
			type: Object,
			required: true
		},
		isDisabled: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			inputVal: this.value
		};
	},
	methods: {
		setValue(value) {
			this.inputVal = value;
		},
		triggerKeys(val) {
			this.$emit('input', val);
		},
		focusLost() {
			this.$emit('lostFocus');
		},
		hasFocus() {
			this.$emit('hasFocus');
		},
		checkType(event) {
			if (this.data.type === 'text') {
				return restrictSpecialCharacters(event);
			} 
			return '';
		}
	}
};
</script>

<style lang="scss" scoped>
.input__wrapper {
	input {
		display: block;
		box-shadow: none;
		border-radius: 14px;
		padding: 14px 16px;
		line-height: 1.2;
		font-size: 14px;
		font-family: $font-main;
		color: $fiord;
		transition: $dur $ease;
		margin: 0;
		border: 1px solid $white-lilac;
		background-color: $white-lilac;

		@include mq($sm) {
			font-size: 16px;
			padding: 13px;
		}

		&:focus {
			border: 1px solid $dodger-blue;
		}

		@include placeholder {
			color: $grey;
		}
	}
}

.no-results .autocomplete-input.focused {
	border-bottom-color: transparent;
	border-radius: 8px 8px 0 0;
}

.no-results .autocomplete-input:not(.focused) ~ #no-results {
	display: none;
}
</style>
